export default __webpack_public_path__ + "static/media/lcl.d51d9098.png";